// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"2669":"c132bf7d","4295":"f8c7e28e","5194":"badf541d","9600":"8ce2b7d0"}[chunkId] || chunkId) + "." + {"2669":"ccaee339db347591","4295":"85d7e394fafef33e","5194":"d244e5c562d51e00","7699":"12a653033731ab67","9169":"f2ca5035d04fae43","9600":"ca89e3d2f48d397a"}[chunkId] + ".js";
};